import { createAction, props } from '@ngrx/store';
import { AlertGroup } from '../_models';

// Action types
export const loadAlertGroups = createAction('[AlertGroup] Load AlertGroups');
export const loadAlertGroupsSuccess = createAction(
  '[AlertGroup] Load AlertGroups Success',
  props<{ alertGroups: AlertGroup[] }>()
);
export const loadAlertGroupsFailure = createAction(
  '[AlertGroup] Load AlertGroups Failure',
  props<{ error: any }>()
);

export const addAlertGroup = createAction(
  '[AlertGroup] Add AlertGroup',
  props<{ alertGroup: AlertGroup }>()
);
export const addAlertGroupSuccess = createAction(
  '[AlertGroup] Add AlertGroup Success',
  props<{ alertGroup: AlertGroup }>()
);
export const addAlertGroupFailure = createAction(
  '[AlertGroup] Add AlertGroup Failure',
  props<{ error: any }>()
);

export const updateAlertGroup = createAction(
  '[AlertGroup] Update AlertGroup',
  props<{ alertGroup: AlertGroup }>()
);
export const updateAlertGroupSuccess = createAction(
  '[AlertGroup] Update AlertGroup Success',
  props<{ alertGroup: AlertGroup }>()
);
export const updateAlertGroupFailure = createAction(
  '[AlertGroup] Update AlertGroup Failure',
  props<{ error: any }>()
);

export const deleteAlertGroup = createAction(
  '[AlertGroup] Delete AlertGroup',
  props<{ id: number }>()
);
export const deleteAlertGroupSuccess = createAction(
  '[AlertGroup] Delete AlertGroup Success',
  props<{ id: number }>()
);
export const deleteAlertGroupFailure = createAction(
  '[AlertGroup] Delete AlertGroup Failure',
  props<{ error: any }>()
);
